import { toYesNo } from "@/api/graphql/migration/helpers.ts";
import type {
  MigrationReportEntry,
  MigrationReportsBO,
  MigrationResult,
} from "@/api/graphql/migration/types.ts";

import type { GetMiddleMsBuildAccountsMigrationReportsQuery } from "../types/graphql";

const mapMigrationResult = (entry: MigrationReportEntry): MigrationResult => ({
  accountNumber: entry.accountNumber,
  accountHasNoPcom: toYesNo(entry.accountHasNoPcom),
  accountNumberIsAct: toYesNo(entry.accountNumberIsAct),
  billingAccountPayerCurrencyIsNull: toYesNo(
    entry.billingAccountPayerCurrencyIsNull,
  ),
  contactEmailIsNull: toYesNo(entry.contactEmailIsNull),
  contactIsNull: toYesNo(entry.contactIsNull),
  contactEmailIsInvalid: toYesNo(entry.contactEmailIsInvalid),
  contractBillingFrequencyCodeIsNull: toYesNo(
    entry.contractBillingFrequencyCodeIsNull,
  ),
  contractContractNumIsNull: toYesNo(entry.contractContractNumIsNull),
  contractExternalContractIdIsNull: toYesNo(
    entry.contractExternalContractIdIsNull,
  ),
  contractHasInvalidStatus: toYesNo(entry.contractHasInvalidStatus),
  contractHasNoScom: toYesNo(entry.contractHasNoScom),
  contractIsNotMb2: toYesNo(entry.contractIsNotMb2),
  contractMissing: toYesNo(entry.contractMissing),
  contractOfferCodeIsNull: toYesNo(entry.contractOfferCodeIsNull),
  contractOfferNameIsNull: toYesNo(entry.contractOfferNameIsNull),
  notPresentInAccountsService: toYesNo(entry.notPresentInAccountsService),
});

export const mapMigrationReportsFromGraphQL = (
  data: GetMiddleMsBuildAccountsMigrationReportsQuery,
): MigrationReportsBO => ({
  diagnosedAccounts:
    data.MiddleMsBuildAccountsMigrationReport.diagnosedAccounts,
  migratedAccounts: data.MiddleMsBuildAccountsMigrationReport.migratedAccounts,
  failedMigrations:
    data.MiddleMsBuildAccountsMigrationReport.failures?.map(
      mapMigrationResult,
    ) ?? [],
  successfulMigrations:
    data.MiddleMsBuildAccountsMigrationReport.successes?.map(
      mapMigrationResult,
    ) ?? [],
});
